export default "__VITE_ASSET__DOU8Z5kl__"